
import Vue from 'vue';
import { IngestDescriptor, Time } from '@/model';
import IngestionStatusBadge from '@/components/IngestionStatusBadge.vue';

export default Vue.extend({
  name: 'IngestionPicker',
  components: {
    IngestionStatusBadge,
  },

  props: {
    value: { type: Object as () => IngestDescriptor | undefined, required: false },
    available: { type: Array as () => IngestDescriptor[], default: () => [] },
  },

  computed: {
    selected: {
      get(): IngestDescriptor | undefined {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },

  methods: {
    dateTime(t: Time) {
      return t && Time.asString(t, true);
    },
    descId(desc: IngestDescriptor) {
      return `${desc.ingestId}/${desc.job?.id}`;
    },
  },

});
